import { Button } from '@platform/components';
import {
  ApplicationResultContent,
  ApplicationResultStepper,
} from '../../components/ApplicationResultContent';
import BackgroundImage from '../../images/Updatedcomposite4.svg';

const steps = [
  {
    label: 'Application submitted',
  },
  {
    label: 'Registration complete',
    content: 'Congrats! After a review of your application, you have successfully been registered.',
  },
  {
    label: 'Get to know your dashboard',
    active: true,
    content: "See what's new in community, and get to know your my projects page.",
  },
  {
    label: 'Join the kickoff call',
    content:
      "We'll be sending you details for your kickoff call shortly. It's a great opportunity to connect with your peers and learn about your upcoming program!",
  },
];
export const ApplicationApproved = () => {
  return (
    <ApplicationResultContent
      title="You're in! What happens next?"
      backgroundImage={BackgroundImage}
      description={
        <div>
          <ApplicationResultStepper steps={steps} />
          <Button
            variant='primary'
            size='lg'
            additionalClassnames='w-full'
            href={`platform/dashboard`}
          >
            See my dashboard
          </Button>
        </div>
      }
    />
  );
};
